import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import type { Worker } from 'types/worker'

const resource = 'favorites'

export const requests = {
  fetchWorkers: (page: number, limit: number) => {
    return axiosForGigbaseBiz.get<DataResponse<Worker[]>>(resource, {
      params: {
        page,
        limit,
      },
    })
  },
  favorite: async (workerId: number) => {
    return await axiosForGigbaseBiz.post<DataResponse<void>>(resource, {
      worker_id: workerId,
    })
  },
  unfavorite: async (workerId: number) => {
    return await axiosForGigbaseBiz.delete<DataResponse<void>>(resource, {
      data: { worker_id: workerId },
    })
  },
}
